/**
 * Function to check if an image exists or not.
 * @param {string} imageUrl
 * @returns {Promise<boolean>} true if the image exists, false otherwise.
 */
export const checkImageExists = async (imageUrl) => {
    return new Promise((resolve) => {
        const img = new Image();
        img.onload = () => resolve(true);  // Successfully loaded
        img.onerror = () => resolve(false); // Failed to load
        img.src = `${imageUrl}?cache_bust=${Date.now()}`; // Cache-bust to avoid false positives
    });
};
